// import 'element-ui/lib/theme-chalk/index.css';
import '../main.scss';
// import i18n from '../i18n.js'
import { createApp} from 'vue';
import { createPinia } from 'pinia'
// if you're using CDN, please remove this line.
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
// import store from '../stores/settings'

// import Connect from './components/Connect.vue';
import Settings from './settings/Settings.vue'
import ElemenetPlus from 'element-plus';
// ElemenetPlus.locale(window.ELEMENT.lang.en)

window.$ = jQuery
// Vue.use(ElementUI);
// Vue.use(i18n)

// Vue.component('wpcm-fields', require('../components/fields/Fields.vue').default);

if( document.querySelector('.wpcm-settings-wrapper') ) {
    const pinia = createPinia();
	const app = createApp(Settings)
    app.use(ElemenetPlus)
    app.use(pinia)
    app.component('wpcm-fields', require('../fields/Fields.vue').default);

    for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
      app.component(`ElIcon${key}`, component)
    }
    app.mount('.wpcm-settings-wrapper');
}



if( document.getElementById('wpcm-admin-live-connect') ) {
	
	// new Vue({
	// 	el: '#wpcm-admin-live-connect',
	// 	components: {
	// 		Connect
	// 	}
	// })
}